import { get } from 'lodash'

const ALL_POSITION_TYPES = [
  'stock',
  'fund',
  'etf',
  'crypto',
  'cash',
  'cfd',
  'putOption',
  'callOption',
  'index',
  'plan',
  'bond',
  'commodity',
  'right',
  'custom',
]
const POSITION_TYPES = [
  'stock',
  'fund',
  'etf',
  'crypto',
  'cash',
  'cfd',
  'putOption',
  'callOption',
  'plan',
  'bond',
  'commodity',
  'right',
  'custom',
]
const WATCH_TYPES = ['stock', 'fund', 'etf', 'crypto', 'cash', 'index', 'commodity', 'bond', 'plan']
const NOT_MARKET_PRICE_TYPES = ['right', 'putOption', 'callOption', 'custom']

const DERIVATIVE_TYPES = ['cfd']
const DERIVATIVE_OPTIONS_TYPES = [
  'stock',
  'fund',
  'etf',
  'crypto',
  'cash',
  'index',
  'bond',
  'commodity',
]

const DIVIDEND_POSITION_TYPES = [
  'stock',
  'fund',
  'etf',
  'crypto',
  'plan',
  'bond',
  'commodity',
  'custom',
]
const COUPON_POSITION_TYPES = ['bond', 'custom']

export const getPositionTypes = ({ model, filterToOnly, filterToHide } = {}) => {
  let positionTypes

  if (model === 'position') positionTypes = POSITION_TYPES
  else if (model === 'watch') positionTypes = WATCH_TYPES
  else if (model === 'notMarketPrice') positionTypes = NOT_MARKET_PRICE_TYPES
  else if (model === 'derivative') positionTypes = DERIVATIVE_TYPES
  else if (model === 'derivativeOptions') positionTypes = DERIVATIVE_OPTIONS_TYPES
  else if (model === 'dividendPositionTypes') positionTypes = DIVIDEND_POSITION_TYPES
  else if (model === 'couponPositionTypes') positionTypes = COUPON_POSITION_TYPES
  else positionTypes = ALL_POSITION_TYPES

  if (filterToOnly && filterToOnly.length) {
    positionTypes = positionTypes.filter((elem) => {
      return filterToOnly.indexOf(elem) > -1
    })
  }

  if (filterToHide && filterToHide.length) {
    positionTypes = positionTypes.filter((elem) => {
      return filterToHide.indexOf(elem) === -1
    })
  }

  return positionTypes
}

// Esta función está replicada en back en api/lib/positions.js
const ISIN_REGEX = /^[A-Z]{2}[A-Z0-9]{9}[0-9]$/
export const isValidIsinFormat = str => Boolean(str && ISIN_REGEX.test(str.toUpperCase()))

export function isPositionDerivative(position) {
  return DERIVATIVE_TYPES.indexOf(position.type) > -1
}

export function getPositionText(position) {
  let text = ``
  if (position.type === 'cfd') text += 'CFD | '
  if (position.type === 'putOption') text += 'PUT | '
  if (position.type === 'callOption') text += 'CALL | '

  const type = getPositionOrDerivativePositionType(position)

  if (
    [
      'stock',
      'right',
      'etf',
      'crypto',
      'putOption',
      'callOption',
      'commodity',
      'index',
      'plan',
      'bond',
      'custom',
    ].indexOf(type) > -1
  ) {
    text = text + (position.name ? `${position.ticker} (${position.name})` : position.ticker)
  } else if (['fund'].indexOf(type) > -1) {
    text = text + `${position.ticker} / ${position.currency}`
    if (position.name) text = text + ` (${position.name})`
  } else if (type === 'cash') {
    text = text + `${position.ticker}` + ' (FX)'
  }
  return text
}

export function getPositionOrDerivativePositionType(position) {
  if (isPositionDerivative(position)) return position.derivativePositionType
  return position.type
}

// Esta función está replicada en back en api/lib/positions.js
export function positionNotMarketPrice(position) {
  if (get(position, 'customMarket.active', false)) return true

  const notMarketPricePositionTypes = getPositionTypes({ model: 'notMarketPrice' })
  const marketType = get(position, 'market.type', null)
  if (marketType && notMarketPricePositionTypes.indexOf(marketType) > -1) return true

  // no tenemos precio para los bonos USA
  if (position.type === 'bond' && position.country === 'US') return true

  return false
}
